import React from "react";

import AppConstants from "../constants/AppConstants";
import UIActions from "../actions/UIActions";
import NameSlugInput from "./NameSlugInput";

const StatePropertiesInfo = ({ stateId, name, slug }) => {
  const _toggleRenamePopup = () => {
    UIActions.toggleRenamePopup({
      title: "View",
      itemType: AppConstants.ITEM_TYPE_STATE,
      itemId: stateId,
      name: name,
      slug: slug,
      showWarning: true,
    });
  };

  return (
    <NameSlugInput
      propName={stateId + ".name"}
      name={name}
      slug={slug}
      labelPrefix="View"
      onAreaFocus={_toggleRenamePopup}
    />
  );
};

export default StatePropertiesInfo;
